<template>
	<div class="card card_custom">
		<header class="card-header">
			<p class="card-header-title">
				{{ cardsTranslations.header.card_status }}
			</p>
			<span v-if="closable" class="card-header-icon" aria-label="close">
				<i @click="$emit('close-card')" class="delete is-normal" aria-hidden="true"></i>
			</span>
		</header>
		<div class="card-content">
			<div class="content">
				<div class="column is-paddingless">
					<div class="columns is-mobile">
						<div class="column is-flex flex-left">{{ cardsTranslations.ordered_label }}</div>
						<div class="column is-flex flex-right">{{ formattedOrderedDate }}</div>
					</div>
					<div v-if="!isCardBlocked" class="columns is-mobile is-hidden-desktop">
						<div class="column is-flex flex-left">{{ cardsTranslations.expiration_label }}</div>
						<div class="column is-flex flex-right">{{ formattedExpiryDate }}</div>
					</div>
					<div class="columns is-mobile">
						<div class="column is-flex flex-left">{{ cardsTranslations.delivery_label }}</div>
						<div class="column is-flex flex-right">
							<span class="is-capitalized">{{ deliveryType }}</span>

						</div>
					</div>

					<div v-if="isCardCreatedAndShipped && card.deliveryType === 'virtual'" class="column is-paddingless is-mobile">
						<div class="has-text-weight-semibold">{{ shippingEmailLabel }}</div> test
						<div>{{ maskedEmail }}</div>
					</div>
					<div v-if="isCardCreatedAndShipped && card.deliveryType !== 'virtual'" class="column is-paddingless is-mobile">
						<div class="has-text-weight-semibold">{{ shippingAddressLabel }}</div>
						<div>{{ card.address_label }}</div>
						<div>{{ deliveryAddress }}</div>
					</div>
					<div v-if="isCardBlocked" class="columns is-paddingless is-mobile">
						<div class="column">
							<i class="fa-solid fa-square has-text-danger"></i>
							<span class="is-capitalized">{{ card.status }}</span>
						</div>
						<div class="column is-flex flex-right">
							{{ formattedBlockingDate }}
						</div>
					</div>
					<div v-if="isCardBlocked" class="columns is-paddingless is-mobile">
						<div class="column">
							<span class="is-capitalized">{{ cardsTranslations.blocking.reason_label }}</span>
						</div>
						<div class="column is-flex flex-right has-text-right">
							{{ cardsTranslations.blocking.reasons_list[card.blockReason] || " -- " }}
						</div>
					</div>
					<div v-if="isCardActivated" class="columns is-paddingless is-mobile">
						<div class="column">
							<i class="fa-solid fa-square has-text-success"></i>
							<span class="is-capitalized">{{ card.status }}</span>
						</div>
						<div class="column is-flex flex-right has-text-right">
							{{ cardsTranslations.since }} {{ formattedActivationDate }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import date from "./mixins/dateFormatMixin";
export default {
	name: "card-info-popup",
	mixins: [date],
	props: {
		card: {type:Object, required:true},
		closable: {type:Boolean, default:false},
		cardsTranslations: Object,
		noAddressLabel: String,
		shippingAddressLabel: String,
		shippingEmailLabel: String
	},
	computed: {
		maskedEmail() {
			let emailSplitted = this.card.beneficiaryEmail.split('@');
			let prefix = emailSplitted[0];
			let suffix = emailSplitted[1];
			var newPrefix = "";
			var newSuffix = "";
			for(var i in prefix){
				if(i>2 && i<prefix.length-1)newPrefix += "*";
				else newPrefix += prefix[i];
			}
			for(var i in suffix){
				if(i>2 && i<suffix.length-4)newSuffix += "*";
				else newSuffix += suffix[i];
			}

			return newPrefix + "@" + newSuffix;
		},
		deliveryAddress() {
			const address = this.card.deliveryAddress;
			return address ?
				address.street + ' ' + address.number + ' ' + address.zip_code + ' ' + address.city :
				this.noAddressLabel;
		},
		deliveryType() {
			return this.cardsTranslations.delivery_type[this.card.deliveryType];
		},
		isCardBlocked() {
			return this.card.status === "blocked";
		},
		isCardCreatedAndShipped() {
			return this.card.status === "created" && this.card.shipped;
		},
		isCardActivated() {
			return this.card.status === "activated";
		},
		formattedOrderedDate() {
			return this.$options.filters.date(this.card.ordered);
		},
		formattedExpiryDate() {
			return this.$options.filters.date(this.card.expiry);
		},
		formattedBlockingDate() {
			return this.$options.filters.date(this.card.blocking);
		},
		formattedActivationDate() {
			return this.$options.filters.date(this.card.activation);
		},
	},
	mounted() {
		if (!$('.card.card_custom').isInViewport())
		{
			$('.card.card_custom').css('bottom', 0).css('position', 'fixed')
		}
	}
};
</script>

<style scoped>
.card_custom {
	position: absolute;
	border-radius: 0.5rem;
	z-index: 1000;
	min-width: 30rem;
	margin-top: -5px;
}
.flex-right {
	justify-content: flex-end;
}
.flex-left {
	justify-content: flex-start;
}
.delete.is-normal {
	font-size: 0.8rem;
}
</style>
